module.exports = __webpack_public_path__ + "static/media/Folder.6d0b1a71.svg";